import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7e0765dd&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0765dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e0765dd')) {
      api.createRecord('7e0765dd', component.options)
    } else {
      api.reload('7e0765dd', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7e0765dd&scoped=true", function () {
      api.rerender('7e0765dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/distribution/setting/agreement/index.vue"
export default component.exports